export default __webpack_public_path__ + "static/media/ding3x.5b8eb6c0.mp3";